export const   sidebarMenus =[{
    btnClass:"btn btn-primary",
    iconType:"home",
    title:"Home"
  },
  {
    btnClass:"btn btn-light",
    iconType:"folder",
    title:"All"
  },
  { 
    btnClass:"btn btn-light",
    iconType:"clock",
    title:"Recent"
  },
  {
    btnClass:"btn btn-light",
    iconType:"star",
    title:"Starred"
  },
  {
    btnClass:"btn btn-light",
    iconType:"alert-circle",
    title:"Recovery"
  },
  {
    btnClass:"btn btn-light",
    iconType:"trash-2",
    title:"Deleted"
  }]